import {
  I18nBase,
  IRapportConfig,
  Locale,
  LocaleCode
} from "@ifit/rapport-core";
import isEmpty from "lodash.isempty";
import Polyglot from "node-polyglot";

export interface IRapportWebPackage {
  config: IRapportConfig;
  phrases: Partial<Record<LocaleCode, Record<string, unknown>>>;
}

export class I18nWebview extends I18nBase {
  instance: this;
  constructor(
    public readonly webPackage: IRapportWebPackage,
    protected polyglot: Polyglot
  ) {
    super(webPackage.config, polyglot);
    this.setLocaleSync(this.NATIVE_LOCALE_CODE, true);
    this.instance = this;
  }

  public setLocaleSync(localeCode: LocaleCode, forceReload = false): boolean {
    if (
      !forceReload &&
      Locale.fromPolyglot(this.polyglot).toString() === localeCode
    ) {
      return false;
    }

    try {
      if (isEmpty(this.webPackage.phrases[localeCode])) {
        throw new Error(
          `No phrases found for locale '${localeCode}' found in loaded web package`
        );
      }

      const locale = Locale.from(localeCode);
      this.polyglot.locale(locale.toPolyglotLocale());
      this.polyglot.replace(this.webPackage.phrases[locale.toString()]);
    } catch (err) {
      console.warn(
        `"WARNING: Phrases for locale code '${localeCode}'. ${err.message}`
      );
      return false;
    }

    return true;
  }

  public extend(webPackage: IRapportWebPackage): void {
    const locale = Locale.fromPolyglot(this.polyglot).toString();
    this.polyglot.extend(webPackage.phrases[locale]);
  }
}
